<style lang="scss" scoped>
.slide-13 {
  background-image: url(../../../assets/module1/slide13/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-left: 100px;
  padding-top: 136px;
  height: calc(100% - 136px);
}
.content {
  max-width: 669px;
}
p {
  color: white;
  padding-left: 60px;
  padding-right: 120px;
  margin-bottom: 50px;
}
h1 {
  font-size: 65px;
  color: #aa252c;
  margin-bottom: 32px;
}
.name {
  font-size: 126px;
  position: absolute;
  top: 170px;
  right: 90px;
}
</style>

<template>
  <div class="slide-13">
    <div class="content">
      <transition name="scale" appear>
        <p v-show="slideIndex == 12">{{ $t("module1.slide13.paragraph") }}</p>
      </transition>
      <transition name="scale" appear>
        <h1
          v-show="slideIndex == 12"
          v-html="$t('module1.slide13.heading')"
          class="delay-1"
        ></h1>
      </transition>
      <transition name="scale" appear>
        <p v-show="slideIndex == 12" class="delay-2">
          {{ $t("module1.slide13.paragraph2") }}
        </p>
      </transition>
      <transition name="scale" appear>
        <p v-show="slideIndex == 12" class="delay-3">
          {{ $t("module1.slide13.paragraph3") }}
        </p>
      </transition>
      <transition name="fadeRight" appear>
        <img
          v-show="slideIndex == 12"
          src="@/assets/module1/slide13/photo-01.png"
          class="chars delay-5"
        />
      </transition>
      <transition name="fadeRight" appear>
        <img
          v-show="slideIndex == 12"
          src="@/assets/module1/slide13/sophia-01.png"
          class="chars delay-4"
        />
      </transition>
      <transition name="fadeRight" appear>
        <h2 v-show="slideIndex == 12" class="name delay-6">
          Sophia
        </h2>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
